import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { FiltersStore } from '@/tools/search/getFiltersStore';

export type FiltersConfigState = {
  filtersStore: FiltersStore | null;
  loading: boolean;
  filtersWithBadgeNew: string[];
};

export const initialState: FiltersConfigState = {
  filtersStore: null,
  loading: false,
  filtersWithBadgeNew: [],
};

const filtersConfigSlice = createSlice({
  name: 'filtersConfig',
  initialState,
  reducers: {
    updateFiltersConfigRequest(state) {
      state.loading = true;
    },

    updateFiltersConfigSuccess(
      state,
      action: PayloadAction<FiltersStore | null>
    ) {
      state.filtersStore = action.payload;
      state.loading = false;
    },

    updateFiltersWithBadgeNew(state, action: PayloadAction<string[]>) {
      state.filtersWithBadgeNew = action.payload;
    },
  },
});

export const filtersConfig = filtersConfigSlice.reducer;

export const {
  updateFiltersConfigRequest,
  updateFiltersConfigSuccess,
  updateFiltersWithBadgeNew,
} = filtersConfigSlice.actions;
